export enum PolicyType {
    'Cargo',
    'Commercial Trucking',
    'General Liability',
    'Workers\' Comp'
}

interface GeneralLiabilityPolicy {
    policyBase: InsurancePolicy,

}

interface CommercialAutoPolicy {
    policyBase: InsurancePolicy,
    bodilyInjuryLiabilityPerPerson: Number,
    bodilyInjuryLiabilityPerAccident: Number,
    propertyDamageLiabilityPerAccident: Number,
    limitOtherThanCollision: Number
}

interface LiabilityPolicy {

}

interface WorkersCompPolicy {
    classification: Array<Number>,
    credits: Array<Number>,
    depositPremium: Number,
    estimatedPayroll: Number,
    policyBase: InsurancePolicy,
    rates: Array<Number>        // Each classification has its own rate
}

interface Endorsement {

}

interface InsurancePolicy {
    id: Number,
    coinsurance: Number, // Percent
    deductible: Number,
    effectiveDate: Date,
    endorsements: Array<Endorsement>,
    expirationDate: Date,
    fkAdditionalInsured: Array<Number>,
    fkInsurer: Number,
    fkPrimaryNamedInsured: Number,
    limitAggregate: Number,
    limitOccurrence: Number,
    policyNumber: string
    policyType: PolicyType,
    premium: Number,    // Factor this out?  i.e. WC = rate * payroll; for premium
    premiumDiscount: Number
}

export default InsurancePolicy